import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	loaderLabel: {
		id: 'loader.announcement',
		defaultMessage: 'Loading',
		description: 'Description for screen reader of the state that this component represents',
	},
});
